'use client';
import React from 'react';
import { SingleSubjectButton } from './SingleSubjectButton';
import { getActiveLocale } from '@/utils/active-locale';
import { useRouter } from 'next/navigation';

export const Buttons = () => {
  const activeLocale = getActiveLocale();
  const navigate = useRouter();

  const handleIT = () => {
    navigate.push('/' + activeLocale + '/voor-talenten/it');
  };

  const handleEngineering = () => {
    navigate.push('/' + activeLocale + '/voor-talenten/engineering');
  };

  return (
    <div className='w-full self-center flex 2xl:ml-20 gap-x-3 mt-6 font-fractul text-body-md'>
      <SingleSubjectButton onClick={handleEngineering} label='Engineering' textColor='text-dark-900' textHoverColor='text-dark-800' bgColor='bg-yellow-600' hoverBgColor='hover:bg-yellow-500' />
      <SingleSubjectButton onClick={handleIT} label='IT' textColor='text-white' textHoverColor='text-white' bgColor='bg-brand-600' hoverBgColor='hover:bg-brand-700' />
    </div>
  );
};
